import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Errors } from '../constants/errors';
import { delay } from '../lib/helpers';
import { SpinningCircles } from 'react-loading-icons';

type VerifiedState = {
  valid: boolean | null;
};

export default function VerifyEmail() {
  const navigate = useNavigate();
  const [verifiedState, setVerifiedState] = useState<VerifiedState>({
    valid: null,
  });
  const [formErrorState, setFormErrorState] = useState('');

  const markAsVerified = async (hash: string): Promise<void> => {
    try {
      const response = await fetch('/api/users/verify', {
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
          accept: 'application/json',
        },
        body: new URLSearchParams({
          emailVerifyHash: hash,
        }),
      });
      const payload = await response.json();
      if (
        response.status !== 200 &&
        payload.error &&
        payload.type === 'USER_VERIFY_EMAIL_FAILED'
      ) {
        setVerifiedState({ valid: false });
        setFormErrorState(Errors.VerificationUnsuccessful);
      } else if (
        response.status !== 200 &&
        payload.error &&
        payload.type === 'USER_VERIFY_EMAIL_MISSING_HASH'
      ) {
        setVerifiedState({ valid: false });
        setFormErrorState(Errors.VerficationMissingHash);
      } else {
        setVerifiedState({ valid: true });
        setFormErrorState('');
        await delay(5000);
        // navigate('/login');
        // TODO this is a hack for now, we need to fix
        window.location.href = 'https://app.bloodygoodtests.com.au';
      }
    } catch (e) {
      setFormErrorState(Errors.ServerError);
      setVerifiedState({ valid: null });
    }
  };

  const getLoginUrl = (): string => {
    // return `/login`;
    // TODO this is a hack for now, we need to fix
    return 'https://app.bloodygoodtests.com.au';
  };

  useEffect(() => {
    // grab the hash if it exists
    const url = new URL(window.location.href);
    const hash = url.searchParams.get('hash');
    if (hash === null || hash === undefined) {
      navigate('/login');
      return;
    }
    markAsVerified(hash);
  }, [navigate]);

  return (
    <div>
      {formErrorState && (
        <div
          className="bg-eirly-100/10 border-t-4 border-eirly-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
          role="alert"
        >
          <div className="flex">
            <div className="py-1 pr-2">
              <svg
                className="fill-current h-6 w-6 text-eirly-500 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
              </svg>
            </div>
            <div>
              <p className="font-bold">Error</p>

              {formErrorState === Errors.ServerError && (
                <p className="text-sm">
                  Server returned an error, please try again later
                </p>
              )}
              {formErrorState === Errors.VerificationUnsuccessful && (
                <p className="text-sm">Unable to verify your email address.</p>
              )}
              {formErrorState === Errors.VerficationMissingHash && (
                <p className="text-sm">
                  The hash provided for verification was invalid.
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      {verifiedState.valid && (
        <div
          className="bg-eirly-alt-100/10 border-t-4 border-eirly-alt-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
          role="alert"
        >
          <div className="flex">
            <div className="py-1 pr-2">
              <svg
                className="fill-current h-6 w-6 text-eirly-alt-500 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
              </svg>
            </div>
            <div>
              <p className="font-bold">Success</p>
              <p className="text-sm">
                Your email was verified successfully. <br />
                Redirecting you to the{' '}
                <a
                  className="text-eirly-600 hover:text-eirly-500"
                  href={getLoginUrl()}
                >
                  login
                </a>{' '}
                page
              </p>
            </div>
          </div>
        </div>
      )}
      {verifiedState.valid === null && (
        <div
          className="bg-eirly-alt-100/10 border-t-4 border-eirly-alt-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
          role="alert"
        >
          <div className="flex">
            <div className="py-1 pr-2">
              <SpinningCircles height={40} fill="#00edc0" />
            </div>
            <div>
              <p className="font-bold">Please wait</p>
              <p className="text-sm">Verifying...</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
